export default "__VITE_ASSET__FZP98BVm__"